import { Settings, X, Volume2, VolumeX, Play, LogOut } from "lucide-react";
import { useLang } from "@/i18n";

// Lightweight pause menu for the bonus rounds: Resume, Sound toggle, Exit.
export default function BonusPauseMenu({ open, onResume, onExit, muted, onToggleSound }) {
  const { t } = useLang();
  if (!open) return null;
  return (
    <div className="absolute inset-0 z-[65] overflow-y-auto overscroll-contain flex items-start justify-center bg-black/85 p-4 scanlines" data-testid="bonus-pause-overlay">
      <div className="pixel-card bg-[#141414] p-5 w-full max-w-xs pop-in my-auto">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-pixel text-base text-[#FFEB3B] pixel-stroke flex items-center gap-2">
            <Settings size={18} strokeWidth={2.5} /> {t("settings", "AJUSTES")}
          </h2>
          <button data-testid="bonus-pause-close-btn" onClick={onResume} className="pixel-btn bg-black/55 text-white p-2">
            <X size={16} strokeWidth={2.5} />
          </button>
        </div>
        <div className="flex flex-col gap-2.5">
          <button data-testid="bonus-pause-resume-btn" onClick={onResume} className="pixel-btn bg-[#4CAF50] text-white px-4 py-3 text-xs flex items-center gap-2 justify-center">
            <Play size={16} strokeWidth={2.5} /> {t("resume", "CONTINUAR")}
          </button>
          <button data-testid="bonus-pause-sound-btn" onClick={onToggleSound} className="pixel-btn bg-[#222] text-white px-4 py-3 text-xs flex items-center justify-between">
            <span className="flex items-center gap-2">{muted ? <VolumeX size={16} /> : <Volume2 size={16} />} {t("soundLabel", "Sonido")}</span>
            <span className={muted ? "text-white/50" : "text-[#4CAF50]"}>{muted ? t("soundOff", "OFF") : t("soundOn", "ON")}</span>
          </button>
          <button data-testid="bonus-pause-exit-btn" onClick={onExit} className="pixel-btn bg-[#444] text-white px-4 py-3 text-xs flex items-center gap-2 justify-center">
            <LogOut size={16} strokeWidth={2.5} /> {t("exitToMenu", "SALIR AL MENÚ")}
          </button>
        </div>
      </div>
    </div>
  );
}
